// 菜单配置
import _ from 'underscore'
import clone from 'clone'

// 框架页
import IndexToC from "@/views/toc/IndexToC.vue";

// 组件列表
const components = {
  hometoc: () => import('@/views/toc/HomeToC.vue'),
  postjobstep1: () => import('@/views/toc/PostJobStep1.vue'),
  postjobstep2: () => import('@/views/toc/PostJobStep2.vue'),
  // openvip: () => import('@/views/toc/OpenVip.vue'),
  // buycount: () => import('@/views/toc/BuyCount.vue'),
  applymember: () => import('@/views/toc/ApplyMember.vue'),
  positionlist: () => import('@/views/toc/PositionList.vue'),
}


// 生成路由
const generateRoute = (menus) => {
  let menusRouter = []
  let homePage = ''
  const handleRoute = (menus) => {
    _.each(menus, (item) => {
      if (item.path) {
        menusRouter.push(item)
        if (item.meta.homePage) {
          homePage = item.path
        }
      }
      if (item.list && item.list.length) {
        handleRoute(item.list)
      }
      if (item.onlyShowInRightContentArea && item.onlyShowInRightContentArea.length) {
        handleRoute(item.onlyShowInRightContentArea)
      }
    })
  }
  handleRoute(clone(menus))
  menusRouter.push({
    path: '',
    redirect: homePage
  })
  //本质上在这里添加路由，那在首页右侧内容区就可以直接切换，而菜单栏不会新增栏目，现在是通过传入的 menus 的 onlyShowInRightContentArea 来控制的
  // menusRouter.push({
  //   name : "postjobstep1",
  //   path: 'postjobstep1',
  //   component : postJobStep1
  // })
  return [{
    path: '/',
    component: IndexToC,
    children: menusRouter
  }]
}

// 生成菜单
const handleMenus = (menus, oldMenus = [], userType) => {
  if (!menus.length) {
    return {
      menus: oldMenus,
      permission: []
    }
  }
  const newMenus = []
  const permission = []
  const recursion = function (menus, newMenus) {
    const dataLength = menus.length
    for (let i = 0; i < dataLength; i++) {
      const item = menus[i]
      if (userType === '1') {
        if (item.type === 2) { // btn
          if (item.perms) {
            permission.push({
              name: item.parentName + '-' + item.name,
              auth: item.perms,
              path: item.url,
              component: item.component
            })
          }
          if (item.url && item.component && components[item.component]) {
            newMenus.push({
              meta: {
                label: item.name || '',
                auth: item.perms || '',
                hide: true
              },
              path: item.url,
              component: components[item.component]
            })
          }
        } else { // menu
          const newItem = {
            meta: {
              label: item.name || '',
              customIcon: item.iconfont ? 'iconfont ' + item.iconfont : '',
              icon: item.icon ? item.icon : '',
              auth: item.perms || '',
              hide: !!item.hidden
            }
          }
          if (item.list && item.list.length) {
            newItem.list = []
            recursion(item.list, newItem.list)
          }
          if (item.onlyShowInRightContentArea && item.onlyShowInRightContentArea.length) {
            newItem.onlyShowInRightContentArea = []
            recursion(item.onlyShowInRightContentArea, newItem.onlyShowInRightContentArea)
          }
          if (item.url && item.component && components[item.component]) {
            newItem.path = item.url
            newItem.name = item.name
            newItem.component = components[item.component]
          }
          newMenus.push(newItem)
        }

      }
      if (userType === '2') {
        if (item.userType === '2') {
          if (item.type === 2) { // btn
            if (item.perms) {
              permission.push({
                name: item.parentName + '-' + item.name,
                auth: item.perms,
                path: item.url,
                component: item.component
              })
            }
            if (item.url && item.component && components[item.component]) {
              newMenus.push({
                meta: {
                  label: item.name || '',
                  auth: item.perms || '',
                  hide: true
                },
                path: item.url,
                component: components[item.component]
              })
            }
          } else { // menu
            const newItem = {
              meta: {
                label: item.name || '',
                customIcon: item.iconfont ? 'iconfont ' + item.iconfont : '',
                icon: item.icon ? item.icon : '',
                auth: item.perms || '',
                hide: !!item.hidden
              }
            }
            if (item.list && item.list.length) {
              newItem.list = []
              recursion(item.list, newItem.list)
            }
            if (item.onlyShowInRightContentArea && item.onlyShowInRightContentArea.length) {
              newItem.onlyShowInRightContentArea = []
              recursion(item.onlyShowInRightContentArea, newItem.onlyShowInRightContentArea)
            }
            if (item.url && item.component && components[item.component]) {
              newItem.path = item.url
              newItem.name = item.name
              newItem.component = components[item.component]
            }
            newMenus.push(newItem)
          }
        }


      }
    }
  }
  recursion(menus, newMenus)
  return {
    menus: oldMenus.concat(newMenus),
    permission: permission
  }
}

// fixed menus
const fixedMenusToC = [
  {
    menuId: 2,
    parentId: 0,
    parentName: null,
    name: '首页',
    url: '/hometoc',
    perms: null,
    type: 1,
    level: 1,
    icon: 'md-mail-open',
    orderNum: 0,
    component: 'hometoc',
    //这个数组只是用来添加右侧内容区路由，而 list 则是子菜单相关的
    onlyShowInRightContentArea: [
      {
        name: "postjobstep1",
        url: '/postjobstep1',
        component: "postjobstep1"
      },
      {
        name: "postjobstep2",
        url: '/postjobstep2',
        component: "postjobstep2"
      },
      // {
      //   name: "openvip",
      //   url: '/openvip',
      //   component: "openvip"
      // }, {
      //   name: "buycount",
      //   url: '/buycount',
      //   component: "buycount"
      // },
    ]
  },
  {
    menuId: 2,
    parentId: 0,
    parentName: null,
    name: '候选人',
    url: '/applymember',
    perms: null,
    type: 1,
    level: 1,
    icon: 'md-mail-open',
    orderNum: 0,
    component: 'applymember',
  },
  {
    menuId: 2,
    parentId: 0,
    parentName: null,
    name: '职位管理',
    url: '/positionlist',
    perms: null,
    type: 1,
    level: 1,
    icon: 'md-mail-open',
    orderNum: 0,
    component: 'positionlist',
  },
]


export {
  components,
  generateRoute,
  handleMenus,
  fixedMenusToC
}
